import { TagModel } from "@app/shared/services/gtm/model/tag.model";

export class ItTagModel extends TagModel {
  category: string;
  action: string;
  label: string;
}
